import styles from "./PermissionsModal.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import {useCallback, useContext, useState, SetStateAction} from "react";
import {ConnectionFactory, DefaultController} from "../../../backends/YiiRoutes";
import {useComponentVisible} from "../../../hooks/useComponentVisible";
import {useMachine} from "@xstate/react";
import {FetchMachine} from "../../machines/FetchMachine";
import {debounce} from "../../../utils/CleversiteUtilities";
import NotificationManager from "../../notifications/NotificationManager";
import {StoreContext} from "../../../stores/StoreLoader";

interface SearchResult {
    id: string,
    title: string,
}

export function PermissionDropdown(props: {
    groupName: string,
    groupId: string,
    setGroupName: SetStateAction<any>,
    setGroupId: SetStateAction<any>,
    provider: "google" | "office365",
}) {
    const {organizationStore, i18nStore} = useContext(StoreContext);
    const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
    const {ref, isComponentVisible, setIsComponentVisible} = useComponentVisible();
    const [groupSearchCurrent, sendGroupSearch] = useMachine(FetchMachine);

    const handleSearchValueChange = useCallback(debounce(async value => {
        sendGroupSearch("FETCH");
        try {
            const results = await ConnectionFactory(
                organizationStore.currentOrganization.id,
                DefaultController.searchPermissionGroups(
                    i18nStore.currentOrgSupportedLocale,
                    value,
                    props.provider,
                )
            );
            sendGroupSearch("FULFILL");
            setIsComponentVisible(true);
            setSearchResults(results as SearchResult[])
        } catch (e) {
            NotificationManager.error('Internal server error. Try again later.');
            sendGroupSearch("REJECT");
        }
    }, 250) as (value: string) => void, [])

    function handleResultClick(result) {
        props.setGroupName(result.title);
        props.setGroupId(result.id);
        setIsComponentVisible(false);
    }

    let dropdown;
    if (searchResults.length > 0) {
        dropdown = <ul key={"hasresults"}>
            {searchResults.map(result => <li key={result.id} role={"button"} onClick={e => {
                handleResultClick(result)
            }}>{result.title}</li>)}
        </ul>
    } else if (props.groupName && groupSearchCurrent.value !== "PENDING" && isComponentVisible) {
        dropdown = <ul key={"noresults"}>
            <li>No Results</li>
        </ul>
    }

    return <div ref={ref} className={styles.dropdownContainer}>
        <div>
            <input
                id="sb-search-groups"
                className="sb-search-groups form-control"
                placeholder="Enter group or OU name"
                value={props.groupName}
                onChange={e => {
                    props.setGroupName(e.target.value);
                    handleSearchValueChange(e.target.value);
                }}
            />
            {groupSearchCurrent.value === "PENDING" &&
                <FontAwesome className={"sb-loading-icon"} prefix={'fas'} spin name="fa-spinner"/>}
        </div>
        {isComponentVisible && <div>
            {dropdown}
        </div>}
    </div>
}